module.exports = __webpack_public_path__ + "img/button_blue.3ce7e371.png";